import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSyncBiometricsService } from 'src/app/services/biometrics/appSyncBiometrics.service';
import { BackButtonService } from 'src/app/services/biometrics/back-button.service';
import { StartBiometrics } from 'src/app/services/biometrics/start-biometrics.service';
import { BIOMETRICS_RESPONSE } from 'src/app/shared/data/biometrics.constants';
import { BiometricsResponse } from 'src/app/shared/interfaces/biometrics.interface';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { AnalyticService } from 'src/app/shared/services/analytic.service';
import { CustomerDataService } from 'src/app/shared/services/customer-data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-biometrics-validator',
  templateUrl: './biometrics-validator.component.html',
  styleUrls: ['./biometrics-validator.component.scss']
})
export class BiometricsValidatorComponent implements OnInit {
  isSuccess: boolean = false;
  assetsUrl = environment.assetsUrl;
  constructor(
    private startBiometrics: StartBiometrics,
    private appsyncService: AppSyncBiometricsService,
    private customerService: CustomerDataService,
    private backButtonService: BackButtonService,
    private analyticsService: AnalyticService,
    private router: Router
  ) {}

  ngOnInit() {
    this.backButtonService.hideBackButton();
    this.startBiometricProccess();
  }

  startBiometricProccess(): void {
    this.startBiometrics.startBiometricProcess().subscribe(
      (r) => {
        if (r.status === 200) {
          this.initAppSync();
          return;
        }
        this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
      },
      (e) => {
        const message = e.message ?? '';
        this.analyticsService.uTagLinkError(
          'Error servicio startBiometricProcess ' + message,
          'error_tech_page'
        );
        this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
      }
    );
  }

  initAppSync(): void {
    this.appsyncService.initAppSyncBiometrics(
      this.customerService.customerConditionData.transactionId
    );
    this.appsyncService.appSyncResponse.subscribe(
      (response: BiometricsResponse) => {
        this.processSyncResponse(response);
      }
    );
  }

  processSyncResponse(response: BiometricsResponse): void {
    if (this.isSuccessResponse(response)) {
      this.isSuccess = true;
      return;
    }

    this.sendAnaliticError(response);

    if (this.isBiometricError(response)) {
      this.router.navigate([routesData.ERRORS.NO_IDENTITY.redirectPath]);
      return;
    }

    if (this.isTechnicalError(response)) {
      this.router.navigate([routesData.ERRORS.TECH_FAILED.redirectPath]);
      return;
    }

    this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
  }

  isTechnicalError(response: BiometricsResponse): boolean {
    return (
      response.data.onBiometricResult.responseCode ===
        BIOMETRICS_RESPONSE.LAMBDA ||
      response.data.onBiometricResult.responseCode === BIOMETRICS_RESPONSE.INFRA
    );
  }

  isBiometricError(response: BiometricsResponse): boolean {
    return (
      response.data.onBiometricResult.responseCode ===
      BIOMETRICS_RESPONSE.BIOMETRIC
    );
  }

  isSuccessResponse(response: BiometricsResponse): boolean {
    return (
      response.data.onBiometricResult.responseCode ===
      BIOMETRICS_RESPONSE.SUCCESS
    );
  }

  sendAnaliticError(response: BiometricsResponse) {
    try {
      const errorMessage = response.data.onBiometricResult.data.message;
      this.analyticsService.uTagLinkError(
        'Error appsync Biometrics ' + errorMessage,
        'error_tech_page'
      );
    } catch (e) {
      console.warn(e);
    }
  }
}
